import {obtenerId} from "../../Modulo_Encriptacion/obtenerId";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";

export const crearCuenta = async (entidad) => {

    let id = obtenerId(entidad.correo)
    entidad.id = id
    entidad.correo = entidad.correo.toLowerCase().replaceAll(' ', '')
    let dox = await guardarDoc('cuentas', entidad)
    return dox

}